import OverviewSegment from './OverviewSegment';

export default OverviewSegment;
